import { Box } from '@mui/material';
import { Schema } from '../../../amplify/data/resource';
import { generateClient } from 'aws-amplify/api';
import { useEffect, useState } from 'react';

const apiClient = generateClient<Schema>();

interface Props {
  fundNumber?: string;
  logoIndex?: string;
  width?: string | number;
  height?: string | number;
}

export const FundLogo: React.FC<Props> = ({
  fundNumber,
  logoIndex,
  width = 'auto',
  height = 'auto',
}) => {
  const [logo, setLogo] = useState<{
    image: string;
    contentType: string | undefined;
  } | null>(null);

  useEffect(() => {
    const fetchLogo = async () => {
      if (!fundNumber && !logoIndex) {
        console.error('Either fundNumber or logoIndex must be provided.');
        return;
      }

      const response = await apiClient.queries.getFundLogo({
        fundNumber,
        logoIndex,
      });
      if (response && response.data) {
        const parsedResponse = JSON.parse(response.data as string);
        setLogo({
          image: parsedResponse.body.image,
          contentType: parsedResponse.body.contentType,
        });
      } else {
        console.error('Fund Logo Not Found');
      }
    };

    fetchLogo();
  }, [fundNumber, logoIndex]);

  return (
    <Box width={width} height={height}>
      {logo && (
        <img
          src={`data:${logo.contentType};base64,${logo.image}`}
          alt={`Fund Logo ${logoIndex}`}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      )}
    </Box>
  );
};
